<!-- 择偶标准 -->

<template>
  <div class="applyInitiation_personal applyInitiation_work">
    <div class="applyInitiation_personal_head">
      <span>择偶标准</span>
      <span class="red">(必填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">年龄</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_age" placeholder="请选择">
            <el-option v-for="(item, index) in ageList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">身高</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_height" placeholder="请选择">
            <el-option v-for="(item, index) in heightList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <!-- <li class="clearfix">
              <div class="applyInitiation_personal_list_name left">体重</div>
              <el-select :disabled="isDisabled" v-model="standardFormData.gr_weight" placeholder="请选择">
                <el-option
                  v-for="(item,index) in weightList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </li> -->
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">学历</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_educate" placeholder="请选择">
            <el-option v-for="(item, index) in educationList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">收入</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_income" placeholder="请选择">
            <el-option v-for="(item, index) in incomeList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">房子</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_house" placeholder="请选择">
            <el-option v-for="(item, index) in houseList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">车子</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_car" placeholder="请选择">
            <el-option v-for="(item, index) in carList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">婚姻状况</div>
          <el-select :disabled="isDisabled" v-model="standardFormData.sp_marital_status" placeholder="请选择">
            <el-option v-for="(item, index) in marriageList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">所在地</div>
          <el-cascader :disabled="isDisabled" v-model="locationList" :options="cityList" @change="handleChangeLocation"> </el-cascader>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">期待结婚时间</div>
          <el-date-picker :disabled="isDisabled" v-model="standardFormData.sp_marry_date" type="year" placeholder="结婚时间"></el-date-picker>
        </li>
      </ul>
      <div class="copy" @click="handleSubmitStandard" v-if="!isDisabled">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'

export default {
  name: 'Standard',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    // 地区列表
    cityList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      standardInfo: { sp_status: 0 },

      ageList: [], // 年龄列表
      heightList: [], // 身高数组
      weightList: [], // 体重列表
      educationList: [], // 学历列表
      incomeList: [], // 收入列表
      houseList: [], // 住房列表
      carList: [], // 车辆列表
      marriageList: [], // 婚姻状况

      locationList: [], //所在地

      standardFormData: {
        sp_age: '',
        sp_height: '',
        sp_educate: '',
        sp_marital_status: '',
        sp_income: '',
        sp_marry_date: '',
        sp_pro: '',
        sp_city: '',

        // 202406 新增
        sp_car: '',
        sp_house: '',
      },
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadUserSpouse()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10长期居住地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;
    const obj = {
      26: 'ageList', // 年龄列表
      27: 'heightList', // 身高数组
      4: 'weightList', // 体重列表
      11: 'educationList', // 学历列表
      15: 'incomeList', // 收入列表
      18: 'houseList', // 住房列表
      19: 'carList', // 车辆列表
      17: 'marriageList', // 婚姻状况
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    //获取择偶标准
    funLoadUserSpouse() {
      this.$axios.post('/api/member/getUserSpouse').then((res) => {
        this.standardInfo.sp_status = res.data.data.sp_status
        if (res.data.code === 0) {
          this.standardInfo = res.data.data
          this.locationList = res.data.data.sp_city
          for (const key in this.standardFormData) {
            this.standardFormData[key] = this.standardInfo[key]
          }
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },

    //选择所在地
    handleChangeLocation(e) {
      this.standardFormData.sp_pro = e[0]
      this.standardFormData.sp_city = e[1]
    },

    //提交择偶标准
    handleSubmitStandard: $DB(function () {
      if (!this.standardFormData.sp_age) return this.$message.error('请选择年龄')
      if (!this.standardFormData.sp_height) return this.$message.error('请选择身高')
      if (!this.standardFormData.sp_educate) return this.$message.error('请选择学历')
      if (!this.standardFormData.sp_income) return this.$message.error('请选择收入')
      if (!this.standardFormData.sp_marital_status) return this.$message.error('请选择婚姻状况')
      if (!this.standardFormData.sp_pro) return this.$message.error('请选择所在地')
      if (!this.standardFormData.sp_marry_date) return this.$message.error('请选择期待结婚时间')

      this.$axios.post('/api/member/userSpouse', this.standardFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
